import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService, HttpMethod} from '../../base-api.service';
import {ElaborationsModelService} from '../../../Models/YuChef/Elaborations/elaborations-model.service';
import {ElaborationStoreForm} from '../../../../Models/YuChef/Elaborations/elaboration-store.model';
import {ElaborationStepStoreForm} from '../../../../Models/YuChef/Elaborations/elaboration-step-store.model';

@Injectable({
  providedIn: 'root'
})
export class ElaborationsApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: ElaborationsModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener los elaborados
   *
   */
  public getElaborations(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getElaboraciones', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener una elaboración
   *
   */
  public getElaborationDetail(id: number): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getElaboracion/' + id, {}, 'get').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener familias de las elaboraciones
   *
   */
  public getElaborationsFamilies(): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('elaborationFamilies', {}, 'get').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Guardar elaboración
   *
   */
  public setElaboration(params: ElaborationStoreForm): Promise<ApiResponse> {
    const endpoint: string = params.id ? 'kitchen/elaborations/' + params.id : 'kitchen/elaborations';
    const formData = params.asFormData();

    if (params.id) {
      formData.append('_method', 'PATCH');
    }

    return new Promise((resolve, reject) => {

      return this.httpCall(endpoint, formData, 'post').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });
  }


  /**
   * Eliminar elaboración
   *
   */
  public deleteElaboration(id: number): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('kitchen/elaborations/' + id, {}, 'delete').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Guardar paso elaboración
   *
   */
  public setElaborationStep(elaborationId: number, params: ElaborationStepStoreForm): Promise<ApiResponse> {
    const endpoint: string = params.id ? `kitchen/elaborations/${elaborationId}/steps/${params.id}` : `kitchen/elaborations/${elaborationId}/steps`;
    const method: HttpMethod = params.id ? 'patch' : 'post';

    return new Promise((resolve, reject) => {

      return this.httpCall(endpoint, params, method).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });
  }


  /**
   * Eliminar paso de la elaboración
   *
   */
  public deleteStep(elaborationId: number, stepId: number): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall(`kitchen/elaborations/${elaborationId}/steps/${stepId}`, {}, 'delete').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }

}
